import { SubCategory } from "@robe/core";
import { OptionType } from "design-system";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { useLayout } from "xcore";

/** Resolve categories to query params object */
export const useSubCategoryFilter = (q: string, subCategories: SubCategory[]) => {
  const { stringify } = useLayout();
  const { query } = useRouter();

  const options = useMemo(() => subCategories.map((c) => ({ label: stringify(c.name), value: c.id })), [subCategories, stringify]);

  const value = useMemo(() => getQueryValueFromFilterOptions(query[q] ?? [], options), [options, q, query]);

  const getQuery = (v?: OptionType<number>[]) => ({ [q]: v ?? value });

  return [{ options, value }, getQuery, q] as const;
};

/**
 * Checks if query value is present in filter options, if so, it returns the filtered value.
 */
export const getQueryValueFromFilterOptions = (query: string | string[], options: OptionType<number>[]) =>
  options.filter((o) => (typeof query === "string" ? query === o.value.toString() : query.includes(o.value.toString())));
